// apps/web/src/components/landing-v2/proofs/LiveProof.tsx
import { useEffect, useState } from 'react'
import { landingMocks } from '../../../data/landingMocks'

/** Theme 03 / Live ceremonies — ticking countdown to the next ceremony.
 *  Pulls host/title/startsAt from landingMocks.nextCeremony.
 *  Reference: handoff .mm-live. */

function formatCountdown(ms: number): string {
  if (ms <= 0) return 'Live now'
  const total = Math.floor(ms / 1000)
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  if (hours >= 24) {
    const days = Math.floor(hours / 24)
    return `${days}d ${pad(hours % 24)}:${pad(minutes)}`
  }
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

export function LiveProof() {
  const { startsAt, host, title } = landingMocks.nextCeremony
  const target = new Date(startsAt).getTime()
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [])

  const display = formatCountdown(target - now)

  return (
    <div
      className="absolute inset-0 flex flex-col justify-end p-[18px]"
      style={{
        background:
          'radial-gradient(ellipse at top, color-mix(in oklab, var(--color-rose) 14%, transparent), transparent 60%)',
      }}
    >
      <div className="absolute left-3.5 right-3.5 top-3.5 flex items-center justify-between">
        <span className="inline-flex items-center rounded-pill border border-rose/30 bg-rose/[0.16] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-rose-light">
          Next ceremony
        </span>
        <span
          className="text-[10px] uppercase text-text-muted"
          style={{ letterSpacing: '0.14em' }}
        >
          8:00 PM
        </span>
      </div>

      <div className="m-auto text-center">
        <div
          className="font-display font-light text-text-primary"
          style={{
            fontSize: '2.6rem',
            lineHeight: 1,
            letterSpacing: '-0.02em',
          }}
          data-countdown
        >
          {display}
        </div>
        <small
          className="mt-1.5 block text-[10px] uppercase text-text-muted"
          style={{ letterSpacing: '0.24em' }}
        >
          {title}
        </small>
      </div>

      <div
        className="flex items-center justify-between border-t pt-2 text-[12px]"
        style={{ borderColor: 'var(--hairline)' }}
      >
        <span className="flex items-center gap-2 text-text-secondary">
          <span
            className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-hairline-strong font-display italic text-text-primary"
            style={{
              background:
                'linear-gradient(135deg, color-mix(in oklab, var(--color-gold-light-legacy) 60%, transparent), color-mix(in oklab, var(--color-astral-violet) 60%, transparent))',
              fontSize: '0.7rem',
            }}
          >
            {host.charAt(0)}
          </span>
          <span>
            <span className="text-text-primary">{host}</span>
            <br />
            <span
              className="text-[9px] uppercase text-text-muted"
              style={{ letterSpacing: '0.12em' }}
            >
              Host · live
            </span>
          </span>
        </span>
        <span
          className="rounded-pill px-3 py-1 text-[11px] font-medium text-accent-contrast"
          style={{ background: 'var(--color-rose)' }}
        >
          Reserve
        </span>
      </div>
    </div>
  )
}
